<template>
  <div>
    <h3 class="pt-0 mt-0 pb-0">{{ $t('viewAnalytics.finances.title') }}
      <v-card elevation="0">
        <v-row class="px-3">
          <v-col cols="6" md="3">
            <date-picker
                outlined
                :date-label="$t('viewAnalytics.start_date')"
                :date.sync="dateInterval.start"
                @change="changeInterval"
            />
          </v-col>
          <v-col cols="6" md="3">
            <date-picker
                outlined
                :date-label="$t('viewAnalytics.end_date')"
                :date.sync="dateInterval.end"
                @change="changeInterval"
            />
          </v-col>
        </v-row>
        <v-row  class="px-3">
          <v-col cols="12">


            <v-progress-circular
                v-if="loadingInProcess.revenue"
                size="64"
                indeterminate
                color="primary"
                class="mx-auto d-block"
            ></v-progress-circular>

            <template v-if="this.revenue && this.revenue.length===0 && !loadingInProcess.revenue">
              <v-alert
                  type="warning"
              >
               {{$t('viewAnalytics.No_data_for_Selected_time_period')}}
              </v-alert>
            </template>


            <!-- выручка по дням-->
            <GChart
                v-if="revenueData && !loadingInProcess.revenue"
                :settings="{ packages: ['corechart'] }"
                :data="revenueData"
                :options="revenueOptions"
                type="LineChart"
                @ready="onChartReady"
            />



            <!-- средний чек по дням -->
            <GChart
                v-if="ARPUData && !loadingInProcess.revenue"
                :settings="{ packages: ['corechart'] }"
                :data="ARPUData"
                :options="ARPUOptions"
                type="LineChart"
                @ready="onChartReady"
            />


            <!-- выручка помесячно-->
            <GChart
                v-if="revenueByMonthData && !loadingInProcess.order_analytics_by_months"
                :settings="{ packages: ['corechart'] }"
                :data="revenueByMonthData"
                :options="revenueByMonthOptions"
                type="LineChart"
                @ready="onChartReady"
            />

            <!--количество сделок по месяцам -->
            <GChart
                v-if="totalNumberOfDealsByMonthData && !loadingInProcess.order_analytics"
                :settings="{ packages: ['corechart'] }"
                :data="totalNumberOfDealsByMonthData"
                :options="totalNumberOfDealsByMonthOptions"
                type="LineChart"
                @ready="onChartReady"
            />

            <!--закрыто часов по месяцам-->
            <GChart
                v-if="sumRepairtimesByMonthData && !loadingInProcess.order_analytics"
                :settings="{ packages: ['corechart'] }"
                :data="sumRepairtimesByMonthData"
                :options="sumRepairtimesByMonthOptions"
                type="LineChart"
                @ready="onChartReady"
            />

            <!-- средний чек по месяцам-->
            <GChart
                v-if="ARPUByMonthData && !loadingInProcess.order_analytics"
                :settings="{ packages: ['corechart'] }"
                :data="ARPUByMonthData"
                :options="ARPUByMonthOptions"
                type="LineChart"
                @ready="onChartReady"
            />

            <!-- доля запчастей по месяцам-->
            <GChart
                v-if="proportionOfPartsByMonthData && !loadingInProcess.order_analytics"
                :settings="{ packages: ['corechart'] }"
                :data="proportionOfPartsByMonthData"
                :options="proportionOfPartsByMonthOptions"
                type="LineChart"
                @ready="onChartReady"
            />

            <!-- наценка на запчасти по месяцам-->
            <GChart
                v-if="averageMarginForPartsByMonthData && !loadingInProcess.order_analytics"
                :settings="{ packages: ['corechart'] }"
                :data="averageMarginForPartsByMonthData"
                :options="averageMarginForPartsByMonthOptions"
                type="LineChart"
                @ready="onChartReady"
            />

            <!-- валовая прибыль % -->
            <GChart
                v-if="grossProfitPerOrderByMonthPercentsData && !loadingInProcess.order_analytics"
                :settings="{ packages: ['corechart'] }"
                :data="grossProfitPerOrderByMonthPercentsData"
                :options="grossProfitPerOrderByMonthPercentsOptions"
                type="LineChart"
                @ready="onChartReady"
            />

            <!-- валовая прибыль -->
            <GChart
                v-if="grossProfitPerOrderByMonthData && !loadingInProcess.order_analytics"
                :settings="{ packages: ['corechart'] }"
                :data="grossProfitPerOrderByMonthData"
                :options="grossProfitPerOrderByMonthOptions"
                type="LineChart"
                @ready="onChartReady"
            />


          </v-col>
        </v-row>
      </v-card>
    </h3>
  </div>
</template>

<script>
import { GChart } from 'vue-google-charts';
import {mapFields} from 'vuex-map-fields';
import DatePicker from "@/components/common/DatePicker";
import CommonMixin from "@/mixins/common";

export default {
  name: "Finances",
  components: {DatePicker, GChart},
  mixins: [CommonMixin],
  data:() => ({

    dateFormat: "DD.MM.YYYY",
    chartsLib: null,
    statuses:{
      READY: 4, //ID в базе, см StatusSystemOrderRepairtime на бэке
      IN_THE_WORK: 3, //ID в базе, см StatusSystemOrderRepairtime на бэке
    },
    dateInterval:{
      start: null,
      end: null
    },
    selectedStartDate: null,
    commonChartOptions: {
      legend: { position: 'bottom' },
      hAxis: {
        format: 'integer',
      },
      vAxis: {
        maxValue:1000,
        format: 'decimal',
        viewWindow: {
          min: 0
        }

      },
      height: 400,
      width:"100%",
      chartArea: {
        width: '95%',
        left:100
      },
      pointSize: 10,
      pointsVisible: true,
      curveType: 'function',
    }
  }),
  created() {
    this.$store.dispatch('targets/get');

    let monthBefore = new Date();
    monthBefore.setMonth(monthBefore.getMonth() - 1);

    let dd = String(monthBefore.getDate()).padStart(2, '0');
    let mm = String(monthBefore.getMonth() + 1).padStart(2, '0'); //January is 0!
    let yyyy = monthBefore.getFullYear();
    this.dateInterval.start = yyyy+'-'+mm + '-' + dd;

    let today = new Date();
    dd = String(today.getDate()).padStart(2, '0');
    mm = String(today.getMonth() + 1).padStart(2, '0'); //January is 0!
    yyyy = today.getFullYear();
    this.dateInterval.end = yyyy+'-'+mm + '-' + dd;
    this.changeInterval();

  },
  watch: {

  },
  computed: {
    ...mapFields('analytics', [
      'revenue',
      'loadingInProcess',
      'order_analytics',
      'order_analytics_by_months'
    ]),
    ...mapFields('targets', [
      'fetched',
      'types',
      'added'
    ]),
    startDateFormatted() {
      return this.$moment(this.dateInterval.start).format(this.dateFormat)
    },
    endDateFormatted() {
      return this.$moment(this.dateInterval.end).format(this.dateFormat)
    },
    targetDealsPerDay(){
      let deals_per_day = this.added.find(item => (item.parameter === 'deals_per_day' && ( ! item.user_id)));
      return deals_per_day && deals_per_day.value || 0;
    },
    targetARPU(){
      let revenue_per_day = this.added.find(item => (item.parameter === 'revenue_per_day' && ( ! item.user_id)));

      if(revenue_per_day && revenue_per_day.value>0 && this.targetDealsPerDay){
        return parseFloat(revenue_per_day.value / this.targetDealsPerDay).toFixed(2)
      }
      return 0;

    },
    orderAnalyticsDataByMonth(){
      if( ! this.order_analytics_by_months.length) return [];
      let ret = [];
      for(let i in this.order_analytics_by_months){
        let item = this.order_analytics_by_months[i];
        let tmp = {...(item)};
        tmp.repairtimes_per_deal = (item.repairtime && item.repairtime.sum_repairtimes && item.total_number_of_deals) ? (item.repairtime.sum_repairtimes/item.total_number_of_deals).toFixed(2) : 0;
        if(tmp.repairtime){
          tmp.repairtime.sum_repairtimes = tmp.repairtime && tmp.repairtime.sum_repairtimes && parseFloat(tmp.repairtime.sum_repairtimes).toFixed(2) || null;
        }
        tmp.ARPU = (item.total_number_of_deals>0) ? (item.total_sum_with_margin / item.total_number_of_deals).toFixed(2) : null;
        tmp.proportion_of_parts = (item.part && item.total_sum_with_margin>0) ? (item.part.sum_with_margin / item.total_sum_with_margin).toFixed(2)*100 : null;
        tmp.average_cost_repairtime = (item.repairtime && item.repairtime.sum_repairtimes>0) ? (item.repairtime.sum_with_margin / item.repairtime.sum_repairtimes).toFixed(2) : null;

        tmp.average_margin_for_parts = (item.part && item.part.sum_with_margin>0) ? (item.part.sum_with_margin / item.part.sum_without_margin-1).toFixed(2)*100 : null;
        tmp.gross_profit_by_month = (item.part) ? ((item.total_sum_with_margin-item.part.sum_without_margin)).toFixed(2) : null;
        tmp.gross_profit_by_month_percent = (item.part) ? ((item.total_sum_with_margin-item.part.sum_without_margin)/item.total_sum_with_margin*100).toFixed(2) : null;
        ret.push(tmp);
      }
      return ret;
    },


    ARPUOptions () {
      if (!this.chartsLib) return null;

      let cfg = {
        title: `${this.$t('viewAnalytics.finances.ARPU.title')} [${this.$t('viewAnalytics.from')} ${this.startDateFormatted} ${this.$t('viewAnalytics.to')} ${this.endDateFormatted}]`,
        colors: ['#d2dbe2', '#0055ff'],
        legend: {position: 'bottom'}
      }
      return {...this.commonChartOptions, ...cfg};
    },

    ARPUData(){
      let res = [];
      if(this.revenue.length){
        res.push(
            [this.$t('viewAnalytics.date'), this.$t('viewAnalytics.finances.in_fact')+'('+this.currencySymbol+')', this.$t('viewAnalytics.finances.planned')+'('+this.currencySymbol+')']
        );
        this.revenue.forEach((item)=>{
          let formattedDate = this.$moment(item.date).format(this.dateFormat)
          res.push([formattedDate, parseFloat(item.cnt>0 ? item.sum/item.cnt : 0), parseFloat(this.targetARPU)]);
        });
        return res;
      }
      return null;
    },

    revenueOptions () {
      if (!this.chartsLib) return null;

      let count = this.revenue.reduce((accumulator, item) => {
        return accumulator + (parseFloat(item.sum) || 0);
      }, 0);

      let cfg = {
        title: `${this.$t('viewAnalytics.finances.revenue.title_by_days')}: ${count} ${this.currencySymbol} [${this.$t('viewAnalytics.from')} ${this.startDateFormatted} ${this.$t('viewAnalytics.to')} ${this.endDateFormatted}]`,
        colors: ['#d2dbe2', '#0055ff'],
        legend: {position: 'bottom'}
      }
      return {...this.commonChartOptions, ...cfg};
    },
    revenueData(){
      let revenueTarget = this.added.find(item => (item.parameter === 'revenue_per_day' && ( ! item.user_id))) || false;
      revenueTarget = revenueTarget ? parseFloat(revenueTarget.value) : 0;

      let res = [];
      if(this.revenue.length){
        res.push(
            [this.$t('viewAnalytics.date'), this.$t('viewAnalytics.finances.in_fact')+'('+this.currencySymbol+')', this.$t('viewAnalytics.finances.planned')+'('+this.currencySymbol+')']
        );
        this.revenue.forEach((item)=>{
          let formattedDate = this.$moment(item.date).format(this.dateFormat)
          res.push([formattedDate, parseFloat(item.sum), revenueTarget]);
        });
        return res;
      }
      return null;
    },

    revenueByMonthData(){
      let res = [];
      if(this.orderAnalyticsDataByMonth.length){
        res.push(
            [this.$t('viewAnalytics.finances.total_sum_with_margin_by_month'), this.$t('viewAnalytics.sum')+'('+this.currencySymbol+')']
        );
        this.orderAnalyticsDataByMonth.forEach((item)=>{
          res.push([`${item.month}.${item.year}`, parseFloat(item.total_sum_with_margin)]);
        });
        return res;
      }
      return null;
    },
    revenueByMonthOptions(){
      if (!this.chartsLib) return null;

      let cfg = {
        title: `${this.$t('viewAnalytics.finances.revenue.title_by_month')}`,
        colors: ['#4db100', '#0055ff'],
        legend: {position: 'none'}
      }
      return {...this.commonChartOptions, ...cfg};
    },

    totalNumberOfDealsByMonthOptions(){
      if (!this.chartsLib) return null;

      let cfg = {
        vAxis: {
          maxValue:10,
          format: 'decimal',
        },
        title: `${this.$t('viewAnalytics.finances.total_number_of_deals_by_month')}`,
        colors: ['#4db100', '#0055ff'],
        legend: {position: 'none'}
      }
      return {...this.commonChartOptions, ...cfg};
    },

    totalNumberOfDealsByMonthData(){ //количество сделок по месяцам
      let res = [];
      if(this.orderAnalyticsDataByMonth.length){
        res.push(
            [this.$t('viewAnalytics.finances.total_number_of_deals'),  this.$t('viewAnalytics.finances.in_fact'), this.$t('viewAnalytics.finances.planned')]
        );
        this.orderAnalyticsDataByMonth.forEach((item)=>{
          let days = this.daysInMonth(item.month, item.year);
          res.push([`${item.month}.${item.year}`, parseFloat(item.total_number_of_deals), parseFloat(days*this.targetDealsPerDay)]);
        });
        return res;
      }
      return null;
    },

    sumRepairtimesByMonthData(){
      let res = [];
      if(this.orderAnalyticsDataByMonth.length){
        res.push(
            [this.$t('viewAnalytics.finances.sum_repairtimes'), this.$t('viewAnalytics.finances.hours')]
        );
        this.orderAnalyticsDataByMonth.forEach((item)=>{
          res.push([`${item.month}.${item.year}`, parseFloat(item.repairtime && item.repairtime.sum_repairtimes) || 0]);
        });
        return res;
      }
      return null;
    },
    sumRepairtimesByMonthOptions(){
      if (!this.chartsLib) return null;

      let cfg = {
        vAxis: {
          maxValue:10,
          format: 'decimal',
        },
        title: `${this.$t('viewAnalytics.finances.sum_repairtimes_by_months')}`,
        colors: ['#d65308'],
        legend: {position: 'none'}
      }
      return {...this.commonChartOptions, ...cfg};
    },

    ARPUByMonthData(){
      let res = [];
      if(this.orderAnalyticsDataByMonth.length){
        res.push(
            [this.$t('viewAnalytics.finances.ARPU.title'),  this.$t('viewAnalytics.finances.in_fact')+'('+this.currencySymbol+')', this.$t('viewAnalytics.finances.planned')+'('+this.currencySymbol+')']
        );
        this.orderAnalyticsDataByMonth.forEach((item)=>{
          let days = this.daysInMonth(item.month, item.year);
          res.push([`${item.month}.${item.year}`, parseFloat(item.ARPU), parseFloat(days*this.targetARPU)]);
        });
        return res;
      }
      return null;
    },
    ARPUByMonthOptions(){
      if (!this.chartsLib) return null;

      let cfg = {
        title: `${this.$t('viewAnalytics.finances.ARPU.title_by_month')}`,
        colors: ['#4db100', '#0055ff'],
        legend: {position: 'none'}
      }
      return {...this.commonChartOptions, ...cfg};
    },

    repairtimesPerDealByMonthData(){
      let res = [];
      if(this.orderAnalyticsDataByMonth.length){
        res.push(
            [this.$t('viewAnalytics.finances.repairtimes_per_deal_by_month'), this.$t('viewAnalytics.finances.hours')]
        );

        this.orderAnalyticsDataByMonth.forEach((item)=>{

          res.push([`${item.month}.${item.year}`, parseFloat(item.repairtimes_per_deal)]);
        });
        return res;
      }
      return null;
    },
    repairtimesPerDealByMonthOptions(){
      if (!this.chartsLib) return null;

      let cfg = {
        title: `${this.$t('viewAnalytics.finances.repairtimes_per_deal_by_month')}`,
        colors: ['#2cb124'],
        legend: {position: 'none'},
        vAxis: {
          maxValue:10,
          format: 'decimal',
          viewWindow: {
            min: 0
          }

        },
      }
      return {...this.commonChartOptions, ...cfg};
    },

    proportionOfPartsByMonthData(){
      let res = [];
      if(this.orderAnalyticsDataByMonth.length){
        res.push(
            [this.$t('viewAnalytics.finances.proportion_of_parts_by_months'), '%']
        );
        this.orderAnalyticsDataByMonth.forEach((item)=>{
          res.push([`${item.month}.${item.year}`, item.proportion_of_parts || 0]);
        });
        return res;
      }
      return null;
    },
    proportionOfPartsByMonthOptions(){
      if (!this.chartsLib) return null;

      let cfg = {
        vAxis: {
          maxValue:100,
        },
        title: `${this.$t('viewAnalytics.finances.proportion_of_parts_by_months')}`,
        colors: ['#aa36ff'],
        legend: {position: 'none'}
      }
      return {...this.commonChartOptions, ...cfg};
    },

    averageMarginForPartsByMonthData(){
      let res = [];
      if(this.orderAnalyticsDataByMonth.length){
        res.push(
            [this.$t('viewAnalytics.finances.average_margin_for_parts'), '%']
        );
        this.orderAnalyticsDataByMonth.forEach((item)=>{
          res.push([`${item.month}.${item.year}`, item.average_margin_for_parts || 0]);
        });
        return res;
      }
      return null;
    },
    averageMarginForPartsByMonthOptions(){
      if (!this.chartsLib) return null;

      let cfg = {
        vAxis: {
          maxValue:100,
        },
        title: `${this.$t('viewAnalytics.finances.average_margin_for_parts_by_months')}`,
        colors: ['#b1260f'],
        legend: {position: 'none'}
      }
      return {...this.commonChartOptions, ...cfg};
    },


    grossProfitPerOrderByMonthPercentsData(){
      let res = [];
      if(this.orderAnalyticsDataByMonth.length){
        res.push(
            [`${this.$t('viewAnalytics.finances.gross_profit_by_month')}, %`, '%']
        );
        this.orderAnalyticsDataByMonth.forEach((item)=>{
          res.push([`${item.month}.${item.year}`, parseFloat(item.gross_profit_by_month_percent) || 0]);
        });
        return res;
      }
      return null;
    },
    grossProfitPerOrderByMonthPercentsOptions(){
      if (!this.chartsLib) return null;

      let cfg = {
        vAxis: {
          maxValue:100,
        },
        title: `${this.$t('viewAnalytics.finances.gross_profit_by_month')}, %`,
        colors: ['#f36600'],
        legend: {position: 'none'}
      }
      return {...this.commonChartOptions, ...cfg};
    },

    grossProfitPerOrderByMonthData(){
      let res = [];
      if(this.orderAnalyticsDataByMonth.length){
        res.push(
            [this.$t('viewAnalytics.finances.gross_profit_by_month'), this.$t('viewAnalytics.sum')+'('+this.currencySymbol+')']
        );
        this.orderAnalyticsDataByMonth.forEach((item)=>{
          res.push([`${item.month}.${item.year}`, parseFloat(item.gross_profit_by_month) || 0]);
        });
        return res;
      }
      return null;
    },
    grossProfitPerOrderByMonthOptions(){
      if (!this.chartsLib) return null;

      let cfg = {
        vAxis: {
          maxValue:100,
        },
        title: `${this.$t('viewAnalytics.finances.gross_profit_by_month')}`,
        colors: ['#2ed700'],
        legend: {position: 'none'}
      }
      return {...this.commonChartOptions, ...cfg};
    },


  },
  methods: {
    onChartReady (chart, google) {
      this.chartsLib = google
    },
    changeInterval(){
      this.$store.dispatch('analytics/get', {
        type: 'revenue', //выручка
        start_date: this.dateInterval.start,
        end_date: this.dateInterval.end,
      })

      this.$store.dispatch('analytics/get', {
        type: 'order_analytics_by_months', //order_analytics
        start_date: this.dateInterval.start,
        end_date: this.dateInterval.end,
      })
    },
    daysInMonth(month,year) {
      return new Date(year, month, 0).getDate();
    }
  }
}
</script>

<style scoped>

</style>